// 個別相談案件一覧のラベル
export const LABELS = {
  TITLE: "交渉事業者一覧",
  BTN_REGISTER: "交渉事業者登録",

  COMPANY_NAME: "事業者名",
  NEGOTIATION_STATUS: "交渉状況",
  CORPORATE_NUMBER: "法人番号",

  IN_NEGOTIATION: "交渉中",
  NEGOTIATION_COMPLETE: "交渉完了",

  REGISTRATION_ATTENTION:
    "登録済み事業者に対する案件追加は、該当事業者の案件更新画面から行ってください。",

  SEARCH_TITLE: "交渉事業者検索",
};
// SELECTの空行の定義
export const SELECT_BLANK = { label: "　", value: "" };
// 交渉状況
export const NEGOTIATION_STATUS_LIST = [
  SELECT_BLANK,
  { label: LABELS.IN_NEGOTIATION, value: "0" },
  { label: LABELS.NEGOTIATION_COMPLETE, value: "1" },
];

// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 20;

// プレースホルダーの内容
export const PLACE_HOLDERS = {
  CORP_NAME: "（記入例）株式会社NTTドコモ",
} as const;
